import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { compose } from 'redux'
import { State } from '../store'
import LoadingScreen from './loading.screen'

interface StateProps {
  authenticated?: boolean
}

type Props = StateProps

const withAuth = (Component: any): React.FC<Props> => {
  return props => {
    const history = useHistory()

    useEffect(() => {
      if (props.authenticated === false) {
        history.push('/auth/login')
      }
    }, [props.authenticated])

    if (props.authenticated === true) {
      return <Component />
    }

    return <LoadingScreen message={'Bitte Warten'} />
  }
}

export default compose(
  connect<StateProps, {}, {}, State>(
    ({auth}) => ({
      authenticated: auth.authenticated,
    })
  ),
  withAuth
)
